module.exports = __webpack_public_path__ + "static/media/vijay.54000d03.jpg";